import { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';
import { ContentUnavailableGenericNoun, getContentUnavailableMessage } from '@vivli/shared/infrastructure/constants';

const containerStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    padding: '40px',
    textAlign: 'center'
};

const messageStyle: CSSProperties = {
    color: Color.DARK_GRAY,
    fontSize: Size.FontSize.Large,
    maxWidth: '600px'
};

//Shown in place of a load indicator when the content could not be loaded at all.
//Without it a failed load is indistinguishable from a slow one and the page spins
//forever. Callers pass the message so it matches the modal they raised (and so it
//uses the caller's translated noun - "study" or "dataset"). DEV-397.
export const ContentUnavailableView = ({ message }: { message?: string }) => {
    return (
        <div style={containerStyle}>
            <div style={messageStyle}>{message ?? getContentUnavailableMessage(ContentUnavailableGenericNoun)}</div>
        </div>
    );
};
